// @ts-check

import "../jsdoc-types"
import { Link, Typography } from "@bonprix/design-system";
import { useRichTextContext } from "./RichTextContext";

export function TableOfContents() {
	const { headings } = useRichTextContext();

	return (
		<div className="service-page-table-of-contents">
			<Typography variant="h2">Inhaltsübersicht</Typography>

			<ul className="service-page-table-of-contents__list">
				{headings?.map((heading) => (
					<li key={ heading.id }>
						<Link href={ `#${heading.id}` }>{ heading.text }</Link>
					</li>
				))}
			</ul>
		</div>
	);
}
